var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:{
    'anx-list': true,
    'no-padding': _vm.noPadding !== null,
    'with-icon': _vm.icon !== null,
    'no-spacing': _vm.noSpacing !== null
  },style:({ listStyleType: _vm.listStyleType, marginBottom: _vm.marginBottom, marginTop: _vm.marginTop })},_vm._l((_vm.items),function(item,i){return _c('li',{key:(i + "-" + item)},[_vm._t(("icon" + i),function(){return [(_vm.icon)?_c('anx-icon',{staticClass:"anx-icon-list",attrs:{"icon":_vm.icon}}):_vm._e()]}),_vm._t(("item" + i),function(){return [_c('span',[_vm._v(" "+_vm._s(item)+" ")])]})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }